import type { LemburEntry, LemburPayload } from "./Lemburtypes";

export interface SubmitResult {
  status: number;
  message: string;
}

export async function submitLemburForm(
  formData: FormData
): Promise<SubmitResult> {
  let apiUrl = process.env.REACT_APP_API_URL_V2 + "/karyawan/absensi/post/lembur";
  const requestOptions = {
    method: "POST",
    body: formData,
    redirect: "follow" as RequestRedirect,
  };

  const result = await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      return { status: 400, message: "Gagal mengirim lembur. Silakan coba lagi.", error: error.message };
    });

  return result;
}

export function buildLemburFormData(payload: LemburPayload): FormData {
  const formData = new FormData();
  formData.append("id_karyawan", String(payload.idKaryawan));
  formData.append("nama_kegiatan", payload.namaKegiatan);
  formData.append("tanggal", payload.tanggal);
  formData.append("mulai", payload.mulai);
  formData.append("sampai", payload.sampai);
  formData.append("keterangan", payload.keterangan);
  formData.append("status", "pending");
  formData.append("submitted_at", new Date().toISOString());
  return formData;
}

export async function getLemburList(id_karyawan: string): Promise<LemburEntry[]> {
  let apiUrl = process.env.REACT_APP_API_URL_V2 + "/karyawan/absensi/lembur/" + id_karyawan;

  const requestOptions = {
    method: "GET",
    redirect: "follow" as RequestRedirect,
  };

  const result = await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => { return { status : 500, message : "Error Saat fetch Ambil data lembur", error : error.message } } );

  if (result && Array.isArray(result.data)) {
    const data = result.data.map((row: any) => {
      // normalize different possible backend field names into LemburEntry
      const id = row.id ?? row.id_lembur ?? row.lembur?.id ?? null;
      const namaKegiatan = row.nama_kegiatan ?? row.namaKegiatan ?? row.lembur?.nama_kegiatan ?? row.lembur?.namaKegiatan ?? (typeof row.nama_kegiatan === 'object' ? row.nama_kegiatan.nama_kegiatan ?? JSON.stringify(row.nama_kegiatan) : undefined) ?? "";
      const tanggal = row.tanggal ?? row.tanggal_lembur ?? row.lembur?.tanggal ?? (row.tanggal ? String(row.tanggal) : "");
      const mulai = row.mulai ?? row.waktu_mulai ?? row.lembur?.mulai ?? "";
      const sampai = row.sampai ?? row.waktu_selesai ?? row.lembur?.sampai ?? "";
      const keterangan = row.keterangan ?? row.catatan ?? row.lembur?.keterangan ?? "";
      const status = row.status ?? row.penyetujuan_aktivitas ?? row.lembur?.status ?? undefined;
      const submittedAt = row.submitted_at ?? row.submittedAt ?? row.lembur?.submitted_at ?? null;

      return {
        id: id !== null ? Number(id) : undefined,
        idKaryawan: parseInt(id_karyawan),
        namaKegiatan,
        tanggal,
        mulai,
        sampai,
        keterangan,
        status,
        submittedAt,
        // include original row for debugging if needed
        ...({} as any),
      } as any;
    });
    if (result.status == 200) return data;
  }

  if (result && result.status) alert("Status : " + result.status + ", Pesan :" + result.message);
  return [];
}
